<template>
  <div class="nav">
    <div class="w">
      <h1>
        <img :src="hrefurl+'/public/footer_home/logo.png'" alt="logo" />
      </h1>
      <ul>
        <li>
          <span class="headerItem" @click="() => this.$router.push('/')">
            <img :src="hrefurl+'/public/icon/shouye.png'" />
            <span>首页</span>
          </span>
        </li>
        <li>
          <span class="headerItem" @click="web">
            <img :src="hrefurl+'/public/icon/website.png'" />
            <span>官网</span>
          </span>
        </li>
        <li>
          <span class="headerItem" @click="() => this.$router.push('/exhibitor')" >
            <img :src="hrefurl+'/public/icon/zhanshang.png'" />
            <span>展商</span>
          </span>
        </li>
        <li>
          <span class="headerItem" @click="() => this.$router.push('/exhibit')">
            <img :src="hrefurl+'/public/icon/zhanpin.png'" />
            <span>展品</span>
          </span>
        </li>
        <li>
          <span class="headerItem" @click="() => this.$router.push('/newProducts')">
            <img :src="hrefurl+'/public/icon/originate.png'" />
            <span>首发首创</span>
          </span>
        </li>
        <li>
          <span class="headerItem" @click="() => this.$router.push('/supply')">
            <img :src="hrefurl+'/public/icon/gongxu.png'" />
            <span>供需对接</span>
          </span>
        </li>
        <li>
          <span class="headerItem" @click="() => webHerf('http://e.cippe.com.cn/live')" >
            <img :src="hrefurl+'/public/icon/live.png'" />
            <span>活动直播</span>
          </span>
        </li>
        <li v-if="this.user.authent * 1 == 0">
          <span class="headerItem fenge" @click="approve">
            <i></i>
            <img :src="hrefurl+'/public/icon/approve.png'" />
            <span style="color: #f08300">展商认证</span>
          </span>
        </li>
        <li v-if="!isLogin * 1">
          <el-button class="denglu headerItem" type="text" @click.stop="goLogin" >
            <img :src="hrefurl+'/public/icon/yonghu.png'" />
            <span>登录</span></el-button
          >
          <el-dialog class="dialog" :visible.sync="dialogVisible1" width="300px" height="426px" :modal-append-to-body="false" append-to-body :before-close="close" >
            <wxlogin
              appid="wx5ad2fbf0e05dfda9"
              :scope="'snsapi_login'"
              :theme="'black'"
              :redirect_uri="head + '%3A%2F%2Fe.cippe.com.cn%2f%23%2f' + path"
              :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30NCiAgICAuaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30NCiAgICAuc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9DQogICAgLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30NCiAgICAuaW1wb3dlckJveCAuc3RhdHVzLnN0YXR1c19icm93c2Vye2Rpc3BsYXk6IGJsb2NrO30NCiAgICAuaW1wb3dlckJveCAuc3RhdHVze2Rpc3BsYXk6IGJsb2NrO30='"
              response_type="code"
              state="c3e9d2cbe3d3ccaf03c3f16e3ed963e8"
            >
            </wxlogin>
          </el-dialog>
        </li>
        <li v-else class="loginUp" style="position: relative">
          <span class="headerItem userSpan"
            @click="
              () => {
                this.$router.push('/user/intentionOrder');
                this.$store.dispatch('userTitle', {
                  url: '/user/merchantsCollection',
                  title: '展商收藏',
                });
              }
            "
          >
            <img :src="user.img" alt="" />{{ user.name ? user.name : user.nickname }}
          </span>
          <ul class="down">
            <li @click="outLogin">退出登录</li>
          </ul>
        </li>
        <li>
          <span
            class="headerItem fenge"
            @click="appHerf('https://e.cippe.com.cn/en')"
          >
            <span class="qiehuan">English</span>
          </span>
        </li>
      </ul>
    </div>
    <el-dialog
      title="修改个人信息"
      :visible.sync="information"
      @open="open"
      :append-to-body="true"
      width="700px"
      top="3vh"
      :before-close="resetForm"
      class="tanchaung"
      center
    >
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="昵称" prop="name">
          <el-input v-model="ruleForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input type="email" v-model="ruleForm.email" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item label="单位名称" prop="corpname">
          <el-input v-model="ruleForm.corpname"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="duties">
          <el-input v-model="ruleForm.duties"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model.number="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code" ref="code">
          <el-input v-model="ruleForm.mobileVerify" class="phoneCode" ></el-input>
          <el-button class="button" :disabled="disabled" @click="reqCode">{{ countdown }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" >修改</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog class="approve" :visible="approveState" width="300px" append-to-body :before-close="cancel" >
      <h2 class="approveTitle">展商认证</h2>
      <el-form :model="approveData" status-icon ref="approveTitle" class="demo-ruleForm" >
        <el-form-item prop="username" :rules="[{ required: true, message: '请输入账号', trigger: 'blur' }]" >
          <el-input v-model="approveData.username" placeholder="请输入账号" ></el-input>
        </el-form-item>
        <el-form-item prop="password" :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]" >
          <el-input type="password" placeholder="请输入密码" v-model="approveData.password" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item class="approvebutton">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="approvego('approveTitle')" >认证</el-button >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import wxlogin from "vue-wxlogin";
import { mapState } from "vuex";
import {
  reqLogin,
  reqSendCode,
  reqMyinfoEdit,
  reqMyCorpAuth,
  reqEmail,
} from "../../api";
export default {
  components: { wxlogin },
  data() {
    var checkName = (rule, value, callback) => {
      //M昵称
      if (!value.trim()) return callback(new Error("昵称不能为空或空格"));
      else callback();
    };
    var checkEmail = async (rule, value, callback) => {
      //邮箱
      if (/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) {
        //这里发验证请求
        const response = await reqEmail(value);
        if (response.code * 1 == 0) return callback(new Error("邮箱已存在"));
        else callback();
      } else return callback(new Error("请输入邮箱地址"));
    };
    var checkCorpname = (rule, value, callback) => {
      if (!value.trim()) return callback(new Error("请填写单位名称"));
      else callback();
    };
    var checkDuties = (rule, value, callback) => {
      if (!value.trim()) return callback(new Error("请填写您的职位"));
      else callback();
    };
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        this.disabled = true;
        callback(new Error("请输入手机号"));
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          this.disabled = false;
          callback();
        }
      }
    };
    var checkCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        if (this.flagCode) callback(new Error("请输入正确的验证码"));
        else callback();
      }
    };
    return {
      rules: {
        name: [{ required: true, validator: checkName, trigger: "blur" }],
        email: [
          { required: true, validator: checkEmail, trigger: "blur" },
        ],
        corpname: [
          { required: true, validator: checkCorpname, trigger: "blur" },
        ],
        duties: [{ required: true, validator: checkDuties, trigger: "blur" }],
        mobile: [{ required: true, validator: checkPhone, trigger: "blur" }],
        mobileVerify: [
          { required: true, validator: checkCode, trigger: "blur" },
        ],
      },
      ruleForm: {
        name: "",
        email: "",
        corpname: "",
        duties: "",
        mobile: "",
        mobileVerify: "",
      },
      disabled: true, // 发送验证码
      countdown: "发送验证码", // 倒计时
      flagCode: false,
      approveState: false, // 认证状态
      approveData: {
        username: "", // 认证账号
        password: "", // 认证密码
      },
    };
  },
  mounted() {
    // this.isPath1(this)
    // this.open()
  },
  methods: {
    close() {
      //关闭登录框
      this.$store.dispatch("dialog", false);
    },
    async changeLogin(i) {
      //登录请求
      let url = i.split("?");
      if (url.length <= 1) return;
      let data = {};
      url = url[1].split("&");
      data[url[0].split("=")[0]] = url[0].split("=")[1];
      data[url[1].split("=")[0]] = url[1].split("=")[1];
      const response = await reqLogin(data.code, data.state);
      if (response.code * 1 == 1) {
        this.$store.dispatch("dialog", false);
        this.$store.dispatch("userInformation", response.resilt);
        this.$store.dispatch("isLogin", 1);
        this.$router.push("/" + this.path);
      } else if (response.code * 1 == 0) {
        this.err(this, "添加失败，请重试。。。");
      } else if (response.code * 1 == 2) {
        this.err(this, "授权失败，请重试。。。");
      }
    },
    goLogin() {
      //登录成功
      this.isPath1(this)
      this.$store.dispatch("dialog", true);
    },
    outLogin() {
      //退出登录
      this.$store.dispatch("outLogin");
      this.$router.push("/home");
    },
    approve() {
      //展商认证
      if (this.user.status * 1 == 0) {
        this.open();
        // this.
      } else {
        this.approveState = true;
      }
    },
    async reqCode() {
      //获取验证码
      const response = await reqSendCode(this.ruleForm.mobile);
      if (response.code == 1) {
        this.success(this, "验证码发送成功！");
        this.countdown = 90;
        this.disabled = true;
        this.time();
      } else if (response.code == 0) {
        this.err(this, "验证码发送失败，请稍后再试...");
        this.countdown = "发送验证码";
      }
    },
    time() {
      //倒计时
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.countdown = "重新发送验证码";
          this.disabled = false;
        }
      }, 1000);
    },
    submitForm(formName) {
      //提交表单
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          //提交表单数据，发送请求
          const response = await reqMyinfoEdit(this.ruleForm);
          if (response.code == 4) {
            this.$store.dispatch("userInformation", response.resilt);
            this.success(this, "修改成功");
            clearInterval(this.timer);
            // this.centerDialogVisible = false
            this.countdown = "发送验证码";
            this.$store.dispatch("information", false);
            if (this.informationState) {
              this.$store.dispatch("informationState", false);
              return;
            }
            if (this.user.authent * 1 == 0) {
              this.approveState = true;
            }
          } else if (response.code == 3) {
            this.err(this, "修改失败，请稍后重试...");
          } else if (response.code == 2) {
            this.err(this, "修改失败，请稍后重试...");
          } else if (response.code == 1) {
            this.err(this, "验证码不正确,请重新输入...");
            this.flagCode = true;
            // this.$refs.code.validateField(()=>false)
          } else if (response.code == 0) {
            this.err(this, "非法访问！");
          }
        } else {
          return false;
        }
      });
    },
    resetForm() {
      //清空表单
      // this.$refs[formName].resetFields();
      clearInterval(this.timer);
      // this.centerDialogVisible = false
      this.countdown = "发送验证码";
      this.$store.dispatch("information", false);
    },

    open() {
      //打开修改弹窗
      //根据获取来的个人信息 初始显示表单数据
      let { name, email, corpname, duties, mobile } = this.user;
      this.ruleForm = {
        name,
        email,
        corpname,
        duties,
        mobile,
      };
      if (mobile) {
        this.disabled = false;
      }
      //判断是否有手机号 有责将disabled修改发送验证码状态改为false
      // this.centerDialogVisible = true
      // this.$store.dispatch("information",true)
    },

    approvego(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.infoApprove();
        } else {
          return false;
        }
      });
    },
    async infoApprove() {
      const response = await reqMyCorpAuth(
        this.approveData.username,
        this.approveData.password
      );
      if (response.code * 1 == 4) {
        let user = { ...this.user };
        user.authent = 1;
        this.$store.dispatch("userInformation", user);
        this.approveState = false;
        this.success(this, "认证成功！！！");
      } else if (response.code * 1 == 3) {
        this.err(this, "用户名或密码错误，请重新输入");
      } else if (response.code * 1 == 2) {
        this.err(this, "用户名或密码错误，请重新输入");
      } else if (response.code * 1 == 1) {
        this.err(this, "用户名或密码错误，请重新输入");
      } else if (response.code * 1 == 0) {
        this.err(this, "请登录后再认证");
        localStorage.removeItem("islogin");
        localStorage.removeItem("user");
        this.$store.dispatch("userInformation", "");
        this.$store.dispatch("isLogin", 0);
      }
    },
    cancel() {
      //认证关闭
      this.$refs.approveTitle.resetFields();
      this.approveState = false;
      // this.username = ''
      // this.password = ''
    },
    web() {
      this.webHerf("http://www.cippe.com.cn/cn/");
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      isLogin: (state) => state.user.isLogin,
      dialogVisible1: (state) => state.user.dialogVisible1,
      path: (state) => state.user.path,
      head: (state) => state.user.head,
      information: (state) => state.user.information,
      informationState: (state) => state.user.informationState,
    }),
  },
  watch: {
    $route: function (to) {
      this.changeLogin(to.fullPath);
    },
  },
};
</script>

<style scoped>
.nav {
  user-select: none;
  width: 100%;
  background-color: #008baf;
  position: fixed;
  left: 0;
  top: 0;
  border-bottom: 1px solid #fff;
  z-index: 999;
}
.w {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.nav .w > h1 {
  float: left;
  line-height: 60px;
}
.nav .w > h1 > img {
  width: 200px;
}
@media (min-width: 768px) and (max-width: 1200px) {
  .nav .w > h1 {
    display: none;
  }
}
.nav ul {
  /* width: 768px; */
  height: 60px;
  text-align: center;
  background-color: #008baf;
  margin: 0 auto;
  float: right;
}
.nav li {
  display: inline-block;
  /* overflow: hidden; */
}
.nav >>> .el-button--text,
.nav li > span {
  line-height: 60px;
  /* padding-left: 15px;
    padding-right: 15px; */
  padding: 0 10px;
  font-size: 16px;
  color: white;
  display: inline-block;
  font-weight: 600;
  letter-spacing: 0.14em;
}
.headerItem {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
}
.nav li > .fenge {
  padding-left: 0;
}
.nav .fenge > i {
  height: 30px;
  width: 2px;
  background-color: #aaa;
  display: inline-block;
  vertical-align: middle;
  margin-right: 20px;
}
.nav li img {
  height: 20px;
  width: 20px;
  vertical-align: text-bottom;
  margin-right: 2px;
  object-fit: cover;
}
.headerItem:hover span {
  /* text-decoration: underline; */
  border-bottom: 2px solid white;
  line-height: 26px;
  display: inline-block;
}
.dialog >>> .el-dialog__body {
  padding: 0;
}
.userSpan {
  /* width: 130px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 130px;
}
.userSpan > img {
  width: 24px;
  height: 24px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 4px;
}
.loginUp {
  position: relative;
}
.loginUp .down {
  display: none;
  position: absolute;
  background-color: #ffffff;
  left: 0;
  top: 50px;
  width: 120px;
  height: auto;
  border-top: 1px solid #aaa;
  box-shadow: 1px 1px 4px #aaa;
  z-index: 9999;
}
.loginUp:hover .down {
  display: block;
}
.loginUp .down li {
  cursor: pointer;
  color: #000;
  padding: 10px 0;
  text-align: center;
  width: 100%;
  transition: all 0.2s;
}
.loginUp .down li:hover {
  text-decoration: underline;
}
.nav .headerItem .qiehuan {
  letter-spacing: 0px;
  padding: 2px 4px;
  border: 1px solid;
  line-height: 18px;
  display: inline-block;
  font-size: 12px;
  font-weight: initial;
  border-radius: 4px;
  transition: all 0.5s;
}
.nav .headerItem .qiehuan:hover {
  color: #333;
  border-color: #666;
}

/* 修改个人资料 start */
.tanchaung >>> .el-input__inner {
  color: #333;
}
.tanchaung >>> .el-dialog--center .el-dialog__body {
  padding-left: 100px;
  padding-right: 120px;
  text-align: center;
}
.tanchaung >>> .el-button {
  padding: 10px 26px;
}
.tanchaung >>> .el-button + .el-button {
  margin-left: 20px;
}
.button {
  width: 40%;
  height: 40px;
}
.phoneCode {
  width: 56%;
  margin-right: 4%;
}

/* 修改个人资料 end */

/* 认证登录 satrt */
.approve >>> .el-dialog__body {
  padding: 30px 50px;
}
.approveTitle {
  text-align: center;
  line-height: 1.6;
  margin-bottom: 30px;
  color: #333;
  font-size: 20px;
}
/* .approveuser{
    margin: 0 40px 20px;
    width: calc(100% - 80px);
  }
  .approveuser>>>.el-input__inner,
  .approvepass>>>.el-input__inner{
    height: 36px;
    line-height: 1;
  }
  .approvepass{
    margin: 0 40px 20px;
    width: calc(100% - 80px);
  } */
.approvebutton {
  text-align: center;
  padding: 15px 0 60px;
}
.approvebutton >>> .el-button + .el-button {
  margin-left: 20px;
}
.approvebutton >>> .el-button {
  height: 36px;
  line-height: 1;
}
/* 认证登录 end */
</style>